import { BaseComponent } from '../../components/base-component'
import { SidebarFiltersMobile } from './sidebar-filters-mobile'
import { ShopComponent } from './shop'
import { $el, $elParent } from 'src/scripts/utils/utils'

const SHOP_COMPONENT_SELECTOR = 'shop-component'
const SIDEBAR_COMPONENT_SELECTOR = '#SidebarFiltersMobile'

export class FiltersSubmitBtn extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()

    const shop: ShopComponent = $el(SHOP_COMPONENT_SELECTOR)
    const sidebar: SidebarFiltersMobile = $elParent(
      SIDEBAR_COMPONENT_SELECTOR,
      this,
    )

    if (shop && sidebar) {
      const searchParams = [shop.filterQuery, shop.sortQuery].join('&')
      const preparedUrl = `${window.location.pathname}?${
        shop.formatParams(searchParams) || ''
      }`

      shop.updateURL(searchParams, preparedUrl)
      shop.updateShop(preparedUrl)
      sidebar.hide()
    }
  }
}
